import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { BoxProps, box } from './Box'
import { Color, theme } from '../constants'
import { mediaBreakpointGte } from '../utils'

const colors = {
  'dark-blue': {
    accentColor: Color.BLUE,
    backgroundColor: Color.BLUE,
    border: undefined,
    color: Color.WHITE,
  },
  'light-grey': {
    accentColor: Color.BLUE,
    backgroundColor: Color.LIGHT_GREY,
    border: theme.border.style.thin,
    color: undefined,
  },
  red: {
    accentColor: Color.LIGHT_RED,
    backgroundColor: Color.LIGHTER_RED,
    border: `1px solid ${Color.MEDIUM_RED}`,
    color: undefined,
  },
  white: {
    accentColor: Color.BLUE,
    backgroundColor: Color.WHITE,
    border: theme.border.style.thin,
    color: undefined,
  },
}

const ContentBoxElement = styled.div<ContentBoxProps>((props) => {
  const { accentColor, backgroundColor, border, color } = props.color
    ? colors[props.color]
    : colors.white
  const accentBorder = `${theme.border.radius.normal}px solid ${accentColor}`

  return {
    border,
    borderBottom: props.highlightBorder === 'bottom' ? accentBorder : undefined,
    borderLeft: props.highlightBorder === 'left' ? accentBorder : undefined,
    borderRadius: theme.border.radius.normal,
    width: props.fullWidth ? '100%' : undefined,
    ...box(props),
    boxShadow: theme.boxShadow.normal,
    color,
    maxWidth: props.clamped ? CONTENT_BOX_MAX_WIDTH : undefined,
    padding:
      props.spacing === 'compact'
        ? 12
        : props.spacing === 'semi-compact'
          ? 18
          : 24,
    backgroundColor,
    boxSizing: 'border-box',
    [mediaBreakpointGte('md')]: {
      padding:
        props.spacing === 'compact'
          ? 16
          : props.spacing === 'semi-compact'
            ? 24
            : 32,
    },
  }
})

export const CONTENT_BOX_MAX_WIDTH = 640

export type ContentBoxProps = BoxProps & {
  children?: ReactNode
  clamped?: boolean
  color?: 'dark-blue' | 'light-grey' | 'red'
  fullWidth?: boolean
  highlightBorder?: 'bottom' | 'left'
  spacing?: 'compact' | 'normal' | 'semi-compact'
}

export const ContentBox = (props: ContentBoxProps) => {
  const { children, ...boxProps } = props

  return <ContentBoxElement {...boxProps}>{children}</ContentBoxElement>
}
